import React from "react";
import SubmitButton from "../submitButton/SubmitButton";

const WhatsappForm = ({
  whatsappTemplates,
  selectedTemplate,
  onChange,
  onSubmit,
  isLoading,
  translate,
  previewHtml,
}) => (
  <form onSubmit={onSubmit}>
    <div className="grid gap-6 mb-6 md:grid-cols-2">
      <div>
        <label
          htmlFor="whatsappTemplate"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("select-template")}
        </label>
        <select
          id="whatsappTemplate"
          defaultValue={whatsappTemplates?.[0]?._id}
          onChange={onChange}
          className="w-full p-2.5 border rounded-lg bg-gray-50 dark:bg-gray-700 text-sm"
        >
          {whatsappTemplates?.map((opt) => (
            <option key={opt._id} value={opt._id}>
              {opt.name}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-end">
        <SubmitButton
          isLoading={isLoading}
          textLoading={translate("sending")}
          text={translate("send")}
        />
      </div>
    </div>

    <div className="mb-6">
      <span className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {translate("preview")}
      </span>
      <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
    </div>
  </form>
);

export default WhatsappForm;
